import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import StarRating from "./StarRating";

/* function Test() {
  const [movieRating, setMovieRating] = useState(0);
  return (
    <div>
      <StarRating color="blue" maxRating={10} onSetRating={setMovieRating} />
      <p>this movie was rated {movieRating} stars</p>
    </div>
  );
}
 */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
/* <StarRating maxRating={5} />
  <StarRating
    size={24}
    color="red"
    className="test"
    message={["Terrible", "Bad", "Okay", "Good", "Amazing"]}
    defaultRating={3}
  />
  <StarRating
    size={18}
    color="green"
    className="test"
    message={["سئ", "غير مقبول", "مقبول", "جيد", "ممتاز"]}
  /> 
  <Test />
  */
